import ProductListings from "shared/components/dashboard/dashboardListings/productListing";

const DashboardProducts = () => {
  return <ProductListings />;
};

export default DashboardProducts;
